import { render, staticRenderFns } from "./group-edit-page.vue?vue&type=template&id=18981795&"
import script from "./group-edit-page.vue?vue&type=script&lang=ts&"
export * from "./group-edit-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports